import { hasUnresolvedAssistant } from './hasUnresolvedAssistant'

function findLastIndex(list, predicate) {
  for (let i = list.length - 1; i >= 0; i -= 1) {
    if (predicate(list[i])) return i
  }
  return -1
}

function matchingServerUserIndex(serverMessages, localUser) {
  const text = String(localUser?.text ?? '')
  return findLastIndex(
    serverMessages,
    (msg) => msg.role === 'user' && String(msg.text ?? '') === text,
  )
}

export function mergeInterruptedThread(localMessages = [], serverMessages = []) {
  // The request that produced `serverMessages` may have started while the
  // stream was unresolved but settled after SSE completed. Never let that
  // stale response replace a message which is complete in current state.
  if (!hasUnresolvedAssistant(localMessages)) return localMessages

  const localTail = localMessages[localMessages.length - 1]
  // The SSE stream still targets this message's temporary client id. Adopting
  // a partially persisted server row would remove that target, so every later
  // card and completion patch would become a silent no-op. Explicitly
  // interrupted messages set this flag false and still use the recovery merge.
  if (
    localTail?.role === 'assistant'
    && localTail.demoStreamActive
    && localTail.phase1MessageId !== localTail.id
  ) return localMessages

  const localUserIndex = findLastIndex(localMessages, (msg) => msg.role === 'user')
  if (localUserIndex === -1) return localMessages
  const serverUserIndex = matchingServerUserIndex(serverMessages, localMessages[localUserIndex])
  if (serverUserIndex === -1) return localMessages
  const serverTail = serverMessages.slice(serverUserIndex + 1)
  if (!serverTail.some((msg) => msg.role === 'assistant' && (
    String(msg.text ?? '').trim() || msg.phase1Error
  ))) {
    return localMessages
  }
  return [...localMessages.slice(0, localUserIndex + 1), ...serverTail]
}
